import classNames from "classnames";
import React from "react";

import LoadingIcon from "@components/atoms/LoadingIcon";

import { LoadingType } from "@const/enum";

interface IProps {
  type?: LoadingType;
  description?: string;
}

function Loading({ type = LoadingType.Fill, description = "" }: IProps) {
  return (
    <div
      className={classNames(
        "pointer-events-none fixed left-1/2 z-30 -translate-x-1/2 bg-white",
        type === LoadingType.Fill && "top-12.5 h-fill w-screen",
        type === LoadingType.Screen && "top-0 h-screen w-screen",
        type === LoadingType.Content && "top-underTitle h-underTitle w-1/2",
      )}
    >
      <div
        className={classNames(
          "center absolute flex flex-col gap-2.5 text-center",
          type === LoadingType.Fill && "pb-20",
          type === LoadingType.Screen && "pb-12.5",
          type === LoadingType.Content && "pb-48",
        )}
      >
        <LoadingIcon />
        {description ? <p className="whitespace-pre-wrap">{description}</p> : null}
      </div>
      {type === LoadingType.Content && <div className="fixed -left-1/2 bottom-0 w-screen bg-white pc:h-96" />}
    </div>
  );
}

export default Loading;
